import { useContext } from 'react';

import * as DataIngestion from '@mint-sdk/api-data-ingestion';

import { DataFileContext, DataFileContextValue } from './DataFileContext.jsx';

type DataFilePreviewV1 =
  DataIngestion.DataFile.TableDataFilePreviewV1QueryResult;
type DataFilePreviewV2 =
  DataIngestion.DataFile.TableDataFilePreviewV2QueryResult;

export function useDataFileContext<
  V extends 'V1' | 'V2' = 'V1' | 'V2',
>(): DataFileContextValue<
  V extends 'V2' ? DataFilePreviewV2 : DataFilePreviewV1
> {
  return useContext(DataFileContext) as DataFileContextValue<
    V extends 'V2' ? DataFilePreviewV2 : DataFilePreviewV1
  >;
}
